import _ from "lodash";
import api from "@/modules/billing/services/api";
import odataMixin from "@/core/store/mixin/odata";
import crudMixin from "@/core/store/mixin/crud";

const products = {
  LucidComm: 0,
  PricingTool: 0,
  VarianceTable: 0,
  LucidInsights: 0,
  LCError: 0,
  PTError: 0,
  VTError: 0,
  LIError: 0,
  totalError: 0,
  totalAmount: 0,
};
const maping = {
  LucidComm: "LCError",
  PricingTool: "PTError",
  VarianceTable: "VTError",
  LucidInsights: "LIError",
};

const genMapDetail = (value) => {
  const result = [];
  Object.values(value).forEach((org) => {
    const item = {
      ...products,
    };
    // eslint-disable-next-line complexity
    org.forEach((i) => {
      item.organizationId = i.organizationId;
      item.organizationName = i.organization?.name ?? "";
      item.length = org.length;
      item.priceLevel =
        org.length === 1
          ? i.billingInfo.pricingLevelGroup.description
          : "more...";
      item.businessGroupName = i.businessGroup?.name ?? "";
      item.businessGroupId = i.businessGroup?.id ?? "";
      item.totalAmount += i.totalAmount;
      item["id"] = i.id;
      i.billingReportDetails.forEach((j) => {
        item[j.product] += j.totalCount;
        item[maping[j.product]] += j.errorCount;
        item["totalError"] += j.errorCount;
      });
    });
    result.push(item);
  });
  return result;
};

const parseApiResponse = (resp) => {
  let groupedOrdId = _.groupBy(resp, "organizationId");

  return genMapDetail(groupedOrdId);
};

const parseApiResponseDetail = (resp) => {
  const _id = _.groupBy(resp, "id");
  const detail = genMapDetail(_id);

  return resp.map((i) => {
    const nArr = detail.filter((j) => j.id === i.id);
    return {
      ...i,
      reportDetail: nArr,
    };
  });
};

const res = _.merge({}, odataMixin(api), crudMixin(api), {
  namespaced: true,
  actions: {
    getItems({ commit }, payload) {
      return api
        .getItems({ ...payload, expand: "createdByUser" })
        .then((response) => ({
          items: response.data.items,
          totalCount: response.data.count,
        }));
    },
    getReport({ commit }, payload) {
      return api
        .getReport(payload)
        .then((response) => parseApiResponse(response.data));
    },
    reportDetail({ commit }, payload) {
      return api
        .reportDetail(payload)
        .then((response) => parseApiResponseDetail(response.data));
    },
    reportPdf({ commit }, payload) {
      return api.reportPdf(payload).then(response =>{
        const blob = new Blob([response.data], {type: 'application/pdf'})
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = `report.pdf`
        link.click()
      });
    },
  },
});

export default res;
